<template>
  <div class="header2  flex-c" style="margin: 0 auto;margin-top:30px;width: 1146px;">
    <div class="flex " style="margin-left: 22px;justify-content: space-around;align-items: center;width: 100%;">
      <div>
      <img
        @click="()=>selectNavHeader('首页')"
        style="width: 28px;height: 28px;cursor: pointer"
        :src="homeIcon"
        alt="回到首页"/>
    </div>
      <div class="button"
        @click="()=>selectNavHeader('视频直播')"
        :class="[navHeaderState&&navHeaderState.navHeaderActive=='视频直播'?'active':'']">走进现场
      </div>

      <!-- <div class="button"
        @click="()=>selectNavHeader('观众预登记')"
        :class="[navHeaderState&&navHeaderState.navHeaderActive=='观众预登记'?'active':'']"
        style="flex-wrap: wrap;"
      >
        <template v-if="g.isEn">
          <p style="width: 100%;">Visitor</p>
          <p style="width: 100%;">Pre-regitration</p>
        </template>
        <p v-else style="width: 100%;">观众预登记</p>
      </div> -->
      <div class="button"
        @click="()=>selectNavHeader('展会介绍')"
        :class="[navHeaderState&&navHeaderState.navHeaderActive=='展会介绍'?'active':'']">{{$t('lang.展会介绍')}}
      </div>
      <div class="button"
        @click="()=>selectNavHeader('图片直播')"
        :class="[navHeaderState&&navHeaderState.navHeaderActive=='图片直播'?'active':'']">图片直播
      </div>
      <!-- <div class="button"
        @click="()=>selectNavHeader('综合服务')"
        :class="[navHeaderState&&navHeaderState.navHeaderActive=='综合服务'?'active':'']">{{$t('lang.综合服务')}}
      </div> -->
      <div class="button"
        v-if="!isExhibitor"
        @click="()=>selectNavHeader('发布需求')"
        :class="[navHeaderState&&navHeaderState.navHeaderActive=='发布需求'?'active':'']">{{$t('lang.发布需求')}}
      </div>
      <div class="button"
        v-if="isExhibitor"
        @click="()=>selectNavHeader('需求对接')"
        :class="[navHeaderState&&navHeaderState.navHeaderActive=='需求对接'?'active':'']">{{$t('lang.需求对接')}}
      </div>
      <!-- 资料下载 原先是 下届展位预订 -->
      <div class="button"
        @click="()=>selectNavHeader('资料下载')"
        :class="[navHeaderState&&navHeaderState.navHeaderActive=='资料下载'?'active':'']">资料下载
      </div>
      <div class="button"
        v-if="isExhibitor"
        @click="()=>selectNavHeader('采购商')"
        :class="[navHeaderState&&navHeaderState.navHeaderActive=='采购商'?'active':'']">{{$t('lang.采购商')}}
      </div>
      <div class="button"
        v-if="!isExhibitor"
        @click="()=>selectNavHeader('参展商')"
        :class="[navHeaderState&&navHeaderState.navHeaderActive=='参展商'?'active':'']">{{$t('lang.参展商')}}
      </div>

      <!--      Audience-->
      <!-- <template v-if="!isExhibitor">
        <div class="flex">
          <div
            @click="()=>selectNavHeader('参展商')"
            class="button " :class="[navHeaderState&&navHeaderState.navHeaderActive=='参展商'?'active':'']">
            {{$t('lang.参展商')}}
          </div>
          <div @click="()=>selectNavHeader('发布需求')" class="button"
               :class="[navHeaderState&&navHeaderState.navHeaderActive=='发布需求'?'active':'']">{{$t('lang.发布需求')}}
          </div>
          <div @click="()=>selectNavHeader('参观指引')" class="button"
               :class="[navHeaderState&&navHeaderState.navHeaderActive=='参观指引'?'active':'']">{{$t('lang.参观指引')}}
               <div class="guide-tips" v-if="($route.path == '/home' || $route.path == '/home/' || $route.path == '/purchaser/index' || $route.path == '/') && btn1">
                <div class="rotate"></div>
                <p class="align-center">IMPORTANT</p>
                <p>Please confirm you've allowed cookies in your web browser (Chrome), allowed Camera, Microphone and Pop-ups. (Without proper settings, it will affect the interaction with exhibitors.)</p>
                <p>For details please check Visitor Guide or contact us online.</p>
                <div class="go-link">
                  <span @click.stop="closeDialog1">Got it</span>
                </div>
              </div>
          </div>
          <div @click="()=>selectNavHeader('会刊下载')" class="button"
               :class="[navHeaderState&&navHeaderState.navHeaderActive=='会刊下载'?'active':'']">{{$t('lang.会刊下载')}}
          </div>
          <div @click="()=>selectNavHeader('个人中心')" class="button"
               :class="[navHeaderState&&navHeaderState.navHeaderActive=='个人中心'?'active':'']">{{$t('lang.个人中心')}}
          </div>
        </div>
      </template>
      <template v-else>
        <div class="flex">
          <div
            @click="()=>selectNavHeader('采购商')"
            class="button " :class="[navHeaderState&&navHeaderState.navHeaderActive=='采购商'?'active':'']">
            {{$t('lang.采购商')}}
          </div>
          <div @click="()=>selectNavHeader('采购需求')" class="button"
               :class="[navHeaderState&&navHeaderState.navHeaderActive=='采购需求'?'active':'']">{{$t('lang.采购需求')}}
          </div>
          <div @click="()=>selectNavHeader('平台操作指引')" class="button"
               :class="[navHeaderState&&navHeaderState.navHeaderActive=='平台操作指引'?'active':'']">{{$t('lang.平台操作指引')}}
               <div class="guide-tips" v-if="($route.path == '/home' || $route.path == '/home/' || $route.path == '/exhibition/index' || $route.path == '/') && btn1">
                <div class="rotate"></div>
                <p class="align-center">IMPORTANT</p>
                <p>Please confirm you've installed OBS software for live streams, allowed all cookies in your web browser (Chrome), and allowed Camera, Microphone and Pop-ups. (Without proper settings, it will affect the interaction with buyers.)</p>
                <p>For details please check Exhibitor Guide or contact us online. </p>
                <div class="go-link">
                  <span @click.stop="closeDialog1">Got it</span>
                </div>
              </div>
          </div>
          <div @click="()=>selectNavHeader('会刊下载')" class="button"
               :class="[navHeaderState&&navHeaderState.navHeaderActive=='会刊下载'?'active':'']">{{$t('lang.会刊下载')}}
          </div>
          <div @click="()=>selectNavHeader('个人中心')" class="button"
               :class="[navHeaderState&&navHeaderState.navHeaderActive=='个人中心'?'active':'']">{{$t('lang.个人中心')}}
          </div>
        </div>
      </template> -->

    </div>
  </div>
</template>
<script>
  import * as navHeaderStateUtil from '../store/navHeaderStateUtil';
  import * as routerUtil from '@common/utils/routerUtil';
  import {getUserRoleType} from '@common/utils'
  import {
    type_webpage_catalogDownload,
    type_webpage_guideVisit,
    type_webpage_procurementMatchmaking
  } from "../constants";
  import {type_src_supplier, type_src_purchaser} from '@common/constact'
  import {go2home, isExhibitor, setRouterByNavHeaderStateNavHeaderActive} from "../utils";
  import {getLoginUser} from "../../common/utils";

  import icon_blue from  '@wenxing/assets/images/icon-f1-on.png'
  import icon_red from  '@wenxing/assets/images/icon.png'
  export default {
    data() {
      return {
        currentUser: getLoginUser(),
        type_src_supplier: type_src_supplier,
        // homeIcon: this.g.isSz ?icon_blue:icon_red,
        homeIcon: icon_blue,
        btn1: true
      }
    },
    computed: {
      isExhibitor() {
        return getLoginUser() ? getLoginUser().user2src == type_src_supplier : false
      },
      navHeaderState() {
        return this.$store.state.navHeader
        // return navHeaderStateUtil.getState()
      },
      // navHeaderActive() {
      //   return this.navHeaderState && this.navHeaderState.navHeaderActive
      // }
    },
    watch: {},
    methods: {
      selectNavHeader(navHeader) {
        navHeaderStateUtil.commit_update_cacheNavheader(this.$store.state.navHeader.navHeaderActive);

        // if (!['观众预登记', '下届展位预定'].includes(navHeader)) {
          navHeaderStateUtil.commit_update_navheaderactive(navHeader);
        // }
        // console.log('navHeader=============>', navHeader);
        this.setRouterByNavHeaderStateNavHeaderActive(navHeader)
      },
      closeDialog1 () {
        this.btn1 = false
        // window.open('chrome://settings/content/siteDetails?site=https://xzl.coolgua.com', '_blank')
      },
      setRouterByNavHeaderStateNavHeaderActive: setRouterByNavHeaderStateNavHeaderActive.bind(this),
    }
  }
</script>

<style scoped lang="less">
  @import '../styles/color';

  .button {
    background: transparent;
    // width: 172px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: bold;
    color: #fff;
    border-radius: 5px;
    margin-right: 5px;
    position: relative;
    cursor: pointer;
    text-align: center;
    border: none;

    &.active:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 3px;
      background: #fff;
      bottom: 0px;
    }
  }

.guide-tips {
    position: absolute;
    top: 150%;
    background: red;
    color: #fff;
    width: 190%;
    z-index: 9;
    font-size: 12px;
    text-align: start;
    padding: 12px;
    line-height: 16px;
  .align-center {
    transform: translateX(30%);
  }
  .rotate {
    width: 50px;
    height: 50px;
    position: absolute;
    top: -9%;
    background: red;
    z-index: -1;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
  }

  .go-link {
    margin-top: 12px;
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;

    span {
      color: #000;
      background: #fff;
      border-radius: 4px;
      padding: 4px 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/wenxing/components/header2.vue